export default __webpack_public_path__ + "mixed-content-dark.321e0d3e.svg";